import SlTabGroup from '@shoelace-style/shoelace/dist/components/tab-group/tab-group.component.js';
import SlTab from '@shoelace-style/shoelace/dist/components/tab/tab.component.js';
import style from './style.lit.css';

// Overriding shoelace tab component to be able to style shadowdom more properly as ::part is not yet compatible with browsers we are supporting
export default class SlTabCustom extends SlTab {
  static styles = [SlTab.styles, style];
}

customElements.get('sl-tab') || customElements.define('sl-tab', SlTabCustom);

SlTabGroup.prototype.updateScrollControls = function updateScrollControls() {
  // ORIGINAL FUNCTION: https://github.com/shoelace-style/shoelace/blob/next/src/components/tab-group/tab-group.component.ts#L336
  if (this.noScrollControls) {
    this.hasScrollControls = false;
  } else {
    this.hasScrollControls =
      ['top', 'bottom'].includes(this.placement) &&
      this.nav.scrollWidth - this.nav.clientWidth > 2; // We need to add a small margin to avoid twitching error in Safari
  }
};
